import { render } from "./LoginScreen.vue?vue&type=template&id=838e167e"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=838e167e&lang=scss"
script.render = render

export default script